// Skills options
export const Skills = [
  {
    label: "Account Based Marketing Strategy",
    value: "Account Based Marketing Strategy"
  },
  { label: "Agile Development", value: "Agile Development" },
  { label: "AmpScript", value: "AmpScript" },
  { label: "Animation", value: "Animation" },
  {
    label: "Artificial Intelligence Design",
    value: "Artificial Intelligence Design"
  },
  { label: "Augmented Reality Design", value: "Augmented Reality Design" },
  { label: "Blogging", value: "Blogging" },
  { label: "Branding", value: "Branding" },
  { label: "Content Marketing", value: "Content Marketing" },
  { label: "Data Analytics", value: "Data Analytics" },
  { label: "Data Science", value: "Data Science" },
  {
    label: "Demand Generation Marketing",
    value: "Demand Generation Marketing"
  },
  { label: "Direct Mail", value: "Direct Mail" },
  { label: "Email Design", value: "Email Design" },
  { label: "Email Marketing", value: "Email Marketing" },
  { label: "Event Marketing", value: "Event Marketing" },
  { label: "Graphic Design", value: "Graphic Design" },
  { label: "HTML", value: "HTML" },
  { label: "illustration", value: "illustration" },
  { label: "infulencer Marketing", value: "infulencer Marketing" },
  { label: "Java", value: "Java" },
  { label: "JavaScript", value: "JavaScript" },
  { label: "Lead Generation", value: "Lead Generation" },
  { label: "Machine Learning", value: "Machine Learning" },
  { label: "Market Research", value: "Market Research" },
  { label: "MySQL", value: "MySQL" },
  { label: ".NET", value: ".NET" },
  { label: "Paid Adversting Strategy", value: "Paid Adversting Strategy" },
  { label: "Paid Search", value: "Paid Search" },
  { label: "Photography", value: "Photography" },
  { label: "Product Management", value: "Product Management" },
  { label: "Project Management", value: "Project Management" },
  { label: "Public Releation", value: "Public Releations" },
  { label: "Salesforce Admin", value: "Salesforce Admin" },
  { label: "Salesforce Developer", value: "Salesforce Developer" },
  {
    label: "Salesforce Solution Architect",
    value: "Salesforce Solution Architect"
  },
  {
    label: "Search Engine Marketing(SEM)",
    value: "Search Engine Marketing(SEM) "
  },
  {
    label: "Search Engine Optimization(SEO)",
    value: "Search Engine Optimization(SEO)"
  },
  { label: "Social Media Management", value: "Social Media Management" },
  { label: "Social Media Strategy", value: "Social Media Strategy" },
  { label: "Strategic Planning", value: "Strategic Planning" },
  {
    label: "Technical Content Writing",
    value: "Technical Content Writing"
  },
  { label: "UI Design", value: "UI Design" },
  { label: "UX Design", value: "UX Design" },
  { label: "Video Production", value: "Video Production" },
  { label: "Website Design", value: "Website Design" },
  { label: "Website Developement", value: "Website Developement" }
];

export default {
  Skills
};
